module.exports = __webpack_public_path__ + "img/5.95850b86.jpg";